/**
 * @fileoverview Provides a tool for gracefully exiting the program with a final message
 */

import { ToolDefinition } from '@iterator/shared-node/ai/llm_types'
import { print_ai } from '@iterator/shared-node/util/logging'
import { z } from 'zod'

export const FinishAndExitArgs = z.object({
  message: z.string(),
})
export type FinishAndExitArgs = z.infer<typeof FinishAndExitArgs>
export type FinishAndExitCall = { name: 'finishAndExit'; args: FinishAndExitArgs }

export function finishAndExit(message: string): never {
  print_ai(message)
  process.exit(0)
}

export const finishAndExitTool: ToolDefinition = {
  name: 'finishAndExit',
  function: {
    name: 'finishAndExit',
    description:
      "Prints a final message and exits the program. Use this when you are confident you've complete all the tasks you need to do.",
    parameters: {
      type: 'object',
      properties: {
        message: {
          type: 'string',
          description: 'The message to print before exiting',
        },
      },
      required: ['message'],
    },
  },
  execute: async (args: unknown): Promise<string> => {
    const { message } = FinishAndExitArgs.parse(args)
    return finishAndExit(message)
  },
}
